import { render, staticRenderFns } from "./homeLayout.vue?vue&type=template&id=7227adb8&scoped=true"
import script from "./homeLayout.vue?vue&type=script&lang=js"
export * from "./homeLayout.vue?vue&type=script&lang=js"
import style0 from "./homeLayout.vue?vue&type=style&index=0&id=7227adb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227adb8",
  null
  
)

export default component.exports